module.exports = __webpack_public_path__ + "static/media/stage-product-icons-basic.587d76ba.svg";